import axios from "axios";
import Swal from "sweetalert2";

const apiResources = {
  apiKey: "E51JZCO3vrqZCZN3lTnYsnCsaa5bpUe2XVgy5jEnBtcC73I8zn",
  secretKey: "R92rKEzlUt7iLOQxRYxn91BIfTKO7CwciElrSlL3VinLSsxzqr",
  baseUrl: process.env.REACT_APP_BASE_URL,
  endPoint: "index.php",
  imageUploadPass: "asjdhjakshd7687asdne",
  endPointUploadImage: "upload_image.php",
};

export const getUserDetails = () => {
  const userDetails = localStorage.getItem("appUser");

  if (userDetails !== "undefined") {
    return JSON.parse(userDetails);
  } else {
    return false;
  }
};

export const setUserDetails = (param) => {
  localStorage.setItem("appUser", JSON.stringify(param));
};

export const destroyUserDetails = () => {
  localStorage.removeItem("appUser");
  localStorage.removeItem("persist:root");
};

export const apiRequest = async ({
  method = "POST",
  requestType,
  payload = {},
  onUploadProgress = null,
}) => {
  const url = apiResources.baseUrl + apiResources.endPoint;
  const userDetails = getUserDetails();
  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  let timestamp = new Date().getTime();
  let nonce = generateNonce(20);

  if (payload instanceof FormData) {
    defaultHeaders["Content-Type"] = "multipart/form-data";
    let dataElement = JSON.parse(payload.get("data"));
    dataElement.device_app_id = navigator.userAgent;
    dataElement.request_type = requestType;
    dataElement.timestamp = timestamp;
    dataElement.api_key = apiResources.apiKey;
    dataElement.nonce = nonce;
    if (userDetails) {
      dataElement.user_session_token =
        userDetails.user_session.user_session_token;
    }
    const clientApiAccessToken = await generateApiAccessToken(
      "SHA-256",
      apiResources.apiKey +
        apiResources.secretKey +
        dataElement.timestamp +
        dataElement.nonce +
        (userDetails ? dataElement.user_session_token : "")
    );
    dataElement.api_access_token = clientApiAccessToken;
    payload.set("data", JSON.stringify(dataElement));
  } else {
    payload.device_app_id = navigator.userAgent;
    payload.request_type = requestType;
    payload.timestamp = timestamp;
    payload.api_key = apiResources.apiKey;
    payload.nonce = nonce;
    if (userDetails) {
      payload.user_session_token = userDetails.user_session.user_session_token;
    }
    const clientApiAccessToken = await generateApiAccessToken(
      "SHA-256",
      apiResources.apiKey +
        apiResources.secretKey +
        payload.timestamp +
        payload.nonce +
        (userDetails ? payload.user_session_token : "")
    );
    payload.api_access_token = clientApiAccessToken;
  }

  try {
    const response = await axios({
      method,
      url,
      data: payload,
      headers: defaultHeaders,
      onUploadProgress: onUploadProgress,
    });

    if (userDetails === null && response.data.status === 1) {
      if (response.data.error_code === "ERROR_INVALID_USER_SESSION") {
        destroyUserDetails();
        window.location.href = "/login";
        return;
      }
      if (response.data.error_code === "ERROR_USER_NOT_EXISTS") {
        destroyUserDetails();

        const swalFailedMessage = Swal.mixin({
          customClass: {
            popup: 'swal-failed-popup',
            confirmButton: "swal-success",
            title: 'swal-title',
          },
          buttonsStyling: false,
        });
        swalFailedMessage.fire({
          title: "Sorry!",
          html: `<p class='swal-text-html'>User not exists.</p>`,
          imageWidth: 65,
          imageHeight: 60,
          confirmButtonText: "Ok",
          reverseButtons: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/login";
          }
        });
        return;
      }
    }
  
    if (userDetails && response.data.status === 1) {
      if (response.data.error_code === "ERROR_INVALID_USER_SESSION") {
        destroyUserDetails();
        window.location.href = "/login";
        return;
      }
    }
  
    return response;
  } catch (error) {
    const swalFailedMessage = Swal.mixin({
      customClass: {
        popup: 'swal-failed-popup',
        confirmButton: "swal-success",
        title: 'swal-title',
      },
      buttonsStyling: false,
    });
    swalFailedMessage.fire({
      title: "Sorry!",
      html: `<p class='swal-text-html'>${error.message}</p>`,
      imageWidth: 65,
      imageHeight: 60,
      confirmButtonText: "Ok",
    });
    return error
  }
};

const generateApiAccessToken = (algo, str) => {
  return crypto.subtle
    .digest(algo, new TextEncoder("utf-8").encode(str))
    .then((buf) => {
      return Array.prototype.map
        .call(new Uint8Array(buf), (x) => ("00" + x.toString(16)).slice(-2))
        .join("");
    });
};

const generateNonce = (length) => {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};
